import { UserRole } from "../types/userProfile";

export const routePermissions: Record<string, UserRole[]> = {
  '/addtranslation': [UserRole.Contributor, UserRole.Admin]
};